import React from 'react';
import { Button } from 'reactstrap';
import { HeaderLogo } from './HeaderLogo';
import { MainTextAndImage } from './MainTextAndImage';
import { SecondaryText } from './SecondaryText';
import { Footer } from './Footer';

interface PropTypes {
  mainText: string;
  prospectImage: string;
  secondaryText: JSX.Element;
  handleOnClick?: () => void;
  buttonText?: string;
}

export default function StaticPages(props: PropTypes) {
  return (
    <>
      <div className='mx-6'>
        <div className='d-flex flex-column align-items-center'>
          <div className='justify-content-center mx-4 my-4 w-75'>
            <HeaderLogo />
            <div className='row'>
              <div className='card rounded-4 shadow-sm h-100'>
                <div className='app-card-body w-100'>
                  <div className='row h-100'>
                    <div className='col-12'>
                      <div className='py-5 d-flex flex-column'>
                        <MainTextAndImage
                          mainText={props.mainText}
                          prospectImage={props.prospectImage}
                        />
                        <SecondaryText secondaryText={props.secondaryText} />
                        {props.handleOnClick && (
                          <div className='justify-content-center text-center'>
                            <Button
                              color='primary'
                              size='lg'
                              className='mt-4'
                              onClick={props.handleOnClick}
                            >
                              {props.buttonText}
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
